export type MatchScoreTier = 'A' | 'B' | 'C' | 'D' | 'F';

/**
 * Coarse, school-grade letter for the 0-100 job match score, so the donut reads as a quick
 * fit signal instead of inviting a debate over a specific percentage. Display-layer mapping
 * only: the underlying numeric score still drives sorting, ranking, and the color gradient
 * (see getMatchDonutScoreColor) exactly as before, this only changes what gets rendered.
 */
const TIER_BANDS: ReadonlyArray<{ min: number; tier: MatchScoreTier }> = [
  { min: 85, tier: 'A' },
  { min: 70, tier: 'B' },
  { min: 50, tier: 'C' },
  { min: 30, tier: 'D' },
  { min: 0, tier: 'F' },
];

export function mapMatchScoreToTier(score: number): MatchScoreTier {
  const clamped = Math.max(0, Math.min(100, score));
  const band = TIER_BANDS.find((b) => clamped >= b.min);
  return band ? band.tier : 'F';
}
